import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { PercentageofbreakInsertService } from '../../service/percentageofbreak-insert/percentageofbreak-insert.service';

@Component({
	selector: 'app-percentageofbreak-insert',
	templateUrl: './percentageofbreak-insert.component.html',
	providers: [
		PercentageofbreakInsertService,
		HttpModule
	]
})
export class PercentageofbreakInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	percForm: FormGroup;

	constructor(fb: FormBuilder, private percentageofbreakInsertService: PercentageofbreakInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.percForm = fb.group({
			'Porcentagem': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addPerc(value: any) {
		console.log(value);
		this.percentageofbreakInsertService.insertPerc(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Percentual de Quebra editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/porcentagem-quebra');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/porcentagem-quebra');
	}

}



// WEBPACK FOOTER //
// ./src/app/percentageofbreak/component/percentageofbreak-insert/percentageofbreak-insert.component.ts